import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Edit, Network } from 'lucide-react';

import { LanguageSelect } from './';
import { useUpdateLanguageMutation } from '@app/store/slices/users/usersApi';
import notification from '@app/shared/utils/notification';
import { defaultTelegramVibrate, telegramVibrate } from '@app/shared/utils/common';
import { Page } from '@app/routes';
import { Language } from '@app/shared/types/common';
import { adminIcon } from '@app/assets';

interface TopBarProps {
  isMyProfile: boolean;
  isSuperUser: boolean;
}

export function TopBar({ isMyProfile, isSuperUser }: TopBarProps) {
  const { i18n, t } = useTranslation();
  const [updateLanguage, { isLoading: isUpdatingLanguage }] = useUpdateLanguageMutation();

  const handleLanguageChange = async (value: string) => {
    telegramVibrate();

    try {
      await updateLanguage({ language: value as Language }).unwrap();
      void i18n.changeLanguage(value);
    } catch {
      notification.error(t('profile.errors.language_update'));
    }
  };

  return (
    <div className="flex shrink-0 items-center pb-3">
      {isMyProfile && (
        <div className="flex items-center gap-2.5 ml-auto">
          {isSuperUser && (
            <Link to={Page.ADMIN_HOME} className="p-0.5" onClick={defaultTelegramVibrate}>
              <img src={adminIcon} alt="admin" className="w-7" />
            </Link>
          )}
          <LanguageSelect
            value={i18n.language}
            onValueChange={handleLanguageChange}
            disabled={isUpdatingLanguage}
          />
          <Link to={Page.EDIT_PROFILE} className="p-0.5" onClick={defaultTelegramVibrate}>
            <Edit className="size-7 text-accent" />
          </Link>
          {isSuperUser && (
            <Link to={Page.REFERRAL_TREE} className="p-0.5" onClick={defaultTelegramVibrate}>
              <Network className="size-7 text-accent" />
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
